'use client' // Error components must be Client Components

import { RoundButton } from '@/components/buttons/RoundButton'
import { useEffect, useMemo, useState } from 'react'

const isProduction = process.env.NEXT_PUBLIC_STAGE

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    if (!isProduction) {
      return
    }

    const timer = setTimeout(() => {
      reload()
    }, 5000)

    return () => clearTimeout(timer)
  }, [error])

  const reload = () => {
    location.replace('/')
  }

  return (
    <div className="flex flex-col gap-4 pt-12 text-center items-center">
      <h2 className="text-title1 font-bold">문제 발생</h2>

      <div className="leading-7">
        <p>서버 정보 동기화에 오류가 발생하였습니다.</p>
        <p>5초 후에 페이지가 새로고침 됩니다.</p>

        <div className="text-caption1 text-gray-500">{error.message}</div>
      </div>

      <RoundButton label="페이지 새로고침" onClick={reload} />
    </div>
  )
}
